<template>
  <div class="c-collapse">
    <div
      class="c-collapse__header"
      :class="{ 'is-active': isActive }"
      @click.stop="toggle"
    >
      <p class="c-collapse__title"><slot name="title"></slot></p>
    </div>
    <div class="c-collapse__content" :style="cssStyle">
      <div class="c-collapse__inner" ref="content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      height: 0,
      isActive: this.visible,
      isTransition: true
    };
  },

  computed: {
    cssStyle() {
      let style = {
        height: this.height + 'px'
      };
      if (!this.isTransition) {
        style.transition = 'none';
      }
      return style;
    }
  },

  watch: {
    isActive: {
      handler() {
        this.$nextTick(() => {
          this.update();
        });
      },
      immediate: true
    }
  },

  mounted() {
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },

  methods: {
    getHeight() {
      if (!this.isActive || !this.$refs.content) {
        return 0;
      } else {
        return this.$refs.content.getBoundingClientRect().height;
      }
    },
    resize() {
      this.isTransition = false;
      this.update();
    },
    toggle() {
      this.isActive = !this.isActive;
      this.isTransition = true;
    },
    open() {
      this.isActive = true;
      this.isTransition = true;
    },
    update() {
      this.height = this.getHeight();
    }
  }
};
</script>
